<template>
  <v-layout row justify-center>
    <v-dialog v-model="mutableDialog" max-width="305">
      <v-card class="card-wrap">
        <p class="content">
          {{ message }}
        </p>
        <v-card-actions>
          <v-layout justify-center class="actions">
            <v-btn color="primary" @click="$emit('confirm')">
              OK
            </v-btn>
            <v-btn color="negative" @click="$emit('cancel')">
              キャンセル
            </v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: "ConfirmNavigationDialog",
  props: {
    dialog: {
      type: Boolean,
      required: true
    },
    message: {
      type: String,
      required: true
    }
  },
  computed: {
    mutableDialog: {
      get() {
        return this.dialog;
      },
      set(val) {
        if (!val) {
          this.$emit("cancel");
        }
      }
    }
  }
};
</script>

<style scoped>
.card-wrap {
  padding: 20px;
  text-align: center;
}
.actions {
  gap: 16px;
}
</style>
